import React, { useEffect, useState } from 'react';
import { DotIndicator } from '@sololearnorg/sol';
import { aIChatPlaygroundContext, loadingMessages } from '../../aIChatPlaygroundConstants';
import { i18n } from '../../../../symphony';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

export const AIChatPlaygorundResponseLoading = () => {
	const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
	const { isRegenerating } = useContainerData(
		aIChatPlaygroundContext.value,
		AIChatPlaygroundStore,
		['isRegenerating'],
	);
	const [messages] = useState(
		isRegenerating ? ['ai-chat.loading.message-regenerate', ...loadingMessages] : loadingMessages,
	);

	useEffect(() => {
		if (currentMessageIndex < messages.length - 1) {
			const intervalId = setInterval(() => {
				setCurrentMessageIndex((prevMessage) => prevMessage + 1);
			}, 1000);

			return () => { clearInterval(intervalId); };
		}
	}, [currentMessageIndex]);

	return (
		<div className="ai-chat-playground-chat-tab__ai-response-loading">
			{
				isRegenerating && currentMessageIndex === 0
					? i18n.t('ai-chat.loading.message-regenerate')
					: i18n.t(messages[currentMessageIndex])
			}
			<DotIndicator />
		</div>
	);
};
